import SEO from '../seo';
import React from 'react';
import styled from 'styled-components';
import {
  FaPython,
  FaHtml5,
  FaCss3,
  FaReact,
  FaSass,
  FaLinux,
  FaAws,
  FaDocker
} from 'react-icons/fa';
import {
  SiJavascript,
  SiGatsby,
  SiFlutter,
  SiMysql,
  SiMongodb,
  SiFirebase,
  SiHeroku,
  SiVim,
  SiGooglecloud,
  SiGnubash,
  SiTypescript
} from 'react-icons/si';

import { DiGit, DiGithubBadge } from 'react-icons/di';
const SkillContainer = styled.div``;

const SkillContent = styled.p`
  margin: 1rem auto 2.5rem 1rem;
`;
const SkillHeading = styled.div`
  margin: 1.5rem 1rem;
`;

const IconWrapper = styled.div`
  margin: auto 1rem;
  color: var(--color-tertiary);
  &:hover {
    color: var(--color-primary);
  }
`;
const IconContainer = styled.div`
  overflow-x: scroll;
  display: flex;
  ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Picons = [
  <SiJavascript size={50} title="Javascript" />,
  <SiTypescript size={50} title="Typescript" />,

  <FaPython size={50} title="Python" />,
  <FaHtml5 size={50} title="HTML5" />,
  <FaCss3 size={50} title="CSS3" />,
  // <SiCplusplus size={50} title="C++" />,
];
const Ficons = [
  <FaReact size={50} title="React" />,
  <SiGatsby size={50} title="Gatsby" />,
  <FaSass size={50} title="SASS" />,
  <SiFlutter size={50} title="Flutter" />,
];
const Dicons = [
  <SiMysql size={50} title="SQL" />,
  <SiMongodb size={50} title="MongoDB" />,
];
const Ticons = [
  <DiGit size={50} title="Git" />,
  <DiGithubBadge size={50} title="Github" />,

  <FaDocker size={50} title="Docker" />,

  <FaLinux size={50} title="LINUX" />,
  <SiVim size={50} title="Vim" />,
  <SiGnubash size={50} title="Bash" />,
];
const Cicons = [
  <FaAws size={50} title="Amazon Web Services" />,
  <SiGooglecloud size={50} title="Google Cloud Platform" />,
  <SiFirebase size={50} title="Firebase" />,
  <SiHeroku size={50} title="heroku" />,

]
export default function Skills() {
  return (
    <SkillContainer>
      <SEO title="Skills" />

      <SkillContent>Here are some things I can help you with.</SkillContent>
      <SkillHeading>Programming</SkillHeading>
      <IconContainer>
        {Picons.map((e, idx) => (
          <IconWrapper key={idx}>{e}</IconWrapper>
        ))}
      </IconContainer>
      <SkillHeading>Frameworks and Libraries</SkillHeading>
      <IconContainer>
        {Ficons.map((e, idx) => (
          <IconWrapper key={idx}>{e}</IconWrapper>
        ))}
      </IconContainer>
      <SkillHeading>Database</SkillHeading>
      <IconContainer>
        {Dicons.map((e, idx) => (
          <IconWrapper key={idx}>{e}</IconWrapper>
        ))}
      </IconContainer>
      <SkillHeading>Tools</SkillHeading>
      <IconContainer>
        {Ticons.map((e, idx) => (
          <IconWrapper key={idx}>{e}</IconWrapper>
        ))}
      </IconContainer>

      <SkillHeading>Cloud Services</SkillHeading>
      <IconContainer>
        {Cicons.map((e, idx) => (
          <IconWrapper key={idx}>{e}</IconWrapper>
        ))}
      </IconContainer>


    </SkillContainer>
  );
}
